import React from 'react'
import './LoginScreen.css';
import { auth } from '../Core/firebaseCore';


function LoginScreen() {
    const signIn = (e) => {
        e.preventDefault();
        auth.setPersistence("session").then(async () => {
            return auth.signInWithEmailAndPassword(document.getElementById("email").value, document.getElementById("password").value);
        }).catch((error) => {
            var errorMessage = error.message;
            console.log(errorMessage);
            document.getElementById("login-error").innerHTML = errorMessage;
        });
    }

    return (
        <div className="login">
            <div className="login_container"
                style={{ backgroundImage: "url(./images/login_bg.png)" }}>
                <img src="./images/x-pink.png" alt="logo" />
                <h4>Welcome Back</h4>
                <p className="login_container__sub_header">Video library</p>
                <div className="login_form">
                    <form>
                        <span id="login-error"></span>
                        <input type="email" id="email" placeholder="Email" />
                        <input type="password" id="password" placeholder="Password" />
                        <button type="submit" onClick={signIn}>Login</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default LoginScreen
